import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./timetable.css";
import { useNavigate } from "react-router-dom";

export default function TimetableDashboard() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"))?.school;
  const navigate = useNavigate();

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  const [form, setForm] = useState({
    class_id: "",
    section_id: "",
    day: "",        // ✅ DAY (weekly)
    session: "",
  });

  // ================= LOAD CLASSES =================
  useEffect(() => {
    if (!school?.id) return;

    API.get("/school-admin/classes/", {
      headers: { "X-SCHOOL-ID": school.id },
    }).then((res) => {
      setClasses(res.data.classes || []);
    });
  }, [school?.id]);

  // ================= LOAD SECTIONS =================
  useEffect(() => {
    if (!form.class_id || !school?.id) {
      setSections([]);
      setForm((prev) => ({ ...prev, section_id: "" }));
      return;
    }

    API.get(`/school-admin/sections/?class_id=${form.class_id}`, {
      headers: { "X-SCHOOL-ID": school.id },
    }).then((res) => {
      setSections(res.data.sections || []);
    });
  }, [form.class_id, school?.id]);

  // ================= HANDLER =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ================= NEXT =================
  const goNext = () => {
    const { class_id, section_id, day, session } = form;

    if (!class_id || !section_id || !day || !session) {
      return alert("Class, Section, Day and Session are required");
    }

    navigate("/school-admin/timetable/view", {
      state: form, // ✅ weekly flow
    });
  };

  // ================= UI =================
  return (
    <div className="tt-page timetable-dashboard-page">
      <div className="tt-hero">
        <div>
          <span>Timetable setup</span>
          <h2 className="tt-title">Timetable Dashboard</h2>
          <p>Choose class, section, day, and session to create or edit periods.</p>
        </div>
      </div>

      <div className="tt-form">
        {/* CLASS */}
        <label>Class</label>
        <select
          name="class_id"
          value={form.class_id}
          onChange={handleChange}
        >
          <option value="">Select Class</option>
          {classes.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>

        {/* SECTION */}
        <label>Section</label>
        <select
          name="section_id"
          value={form.section_id}
          onChange={handleChange}
          disabled={!sections.length}
        >
          <option value="">Select Section</option>
          {sections.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>

        {/* DAY */}
        <label>Day</label>
        <select
          name="day"
          value={form.day}
          onChange={handleChange}
        >
          <option value="">Select Day</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
          <option value="saturday">Saturday</option>
          <option value="sunday">Sunday</option>
        </select>

        {/* SESSION */}
        <label>Session</label>
        <select
          name="session"
          value={form.session}
          onChange={handleChange}
        >
          <option value="">Select Session</option>
          <option value="morning">Morning</option>
          <option value="evening">Evening</option>
        </select>

        <button className="tt-btn" onClick={goNext}>
          Create / Edit Timetable
        </button>
      </div>
    </div>
  );
}
